import React from "react";

import "./cta.scss";
import UIButton from "components/shared/Button";
import { isAzaform, brandName } from "helpers/brand";

const Cta = () => {
  return (
    <aside className="home-cta__cta">
      <h2>{isAzaform ? `Start collecting responses with ${brandName}` : "Get better feedback today!"}</h2>
      <p className="home-cta__cta-description">
        {isAzaform ? "Create a form in minutes and share it with anyone." : "Stop guessing - start improving."}
      </p>
      <UIButton
        className="home-cta__cta-button"
        type="primary"
        action="link"
        to="/register"
        text={isAzaform ? "Create a free form" : "Get Started For Free"}
        id="cta"
      />
    </aside>
  );
};

export default Cta;
